import React from 'react';
import cn from 'classnames';
import styles from './CheckMarkItem.module.scss';
import { useTheme } from '@support/hooks/use-theme';

export default function Item({ children, title }) {
  const [theme] = useTheme();

  return (
    <div className={cn(styles.item, styles[theme])}>
      <h4 className={styles.title}>{title}</h4>
      {children}
    </div>
  );
}
